import { ExternalButton } from "@sharedComponents/buttons";

import { useConfig } from "@stadium/hooks/lib/use-config";

import { getBookACallCtaText } from "@stadium/shared/src/selectors/book-a-call";

import { BOOK_A_CALL, OFFERINGS_PATH } from "@constants/routes";
import {
  GET_STARTED_CTA,
  OFFERINGS,
  OFFERINGS_FLOW_SERVICES,
  SPEAK_WITH_AN_EXPERT,
  SWAG_CATALOG,
} from "@constants/june-so";

import styles from "./main.module.scss";

const MarketingFooterLinks = () => {
  const bookACallCtaText = useConfig(getBookACallCtaText);
  return (
    <div className={styles.modalFooterCtaRow}>
      <ExternalButton
        href={BOOK_A_CALL}
        className={styles.modalFooterRowBtn}
        styleType="primary-outline"
        analytics={{
          componentName: SWAG_CATALOG,
          target: SPEAK_WITH_AN_EXPERT,
        }}
      >
        {bookACallCtaText}
      </ExternalButton>
      <ExternalButton
        styleType="primary"
        href={OFFERINGS_PATH}
        className={styles.modalFooterRowBtn}
        analytics={{
          componentName: OFFERINGS,
          target: GET_STARTED_CTA,
          services: OFFERINGS_FLOW_SERVICES,
        }}
      >
        GET STARTED
      </ExternalButton>
    </div>
  );
};

export default MarketingFooterLinks;
